import {
  Input,
  Output,
  EventEmitter,
  ElementRef,
  Directive,
  OnInit,
} from '@angular/core';

declare var jQuery: any;

@Directive({
    selector: '[appDatePickerDirective]',
    standalone: false
})
export class DatePickerDirective implements OnInit {
  // @Input('myDatepicker') myDatepicker: string;

  @Input() value;
  @Input() startDate;
  @Input() endDate;
  @Input() minimumDate = false;
  @Input() onlyDatePicker = false;
  @Output() dateChange = new EventEmitter();
  @Output() hideDatePickerEmit = new EventEmitter();

  constructor(public el: ElementRef) {}

  ngOnInit() {
    jQuery(this.el.nativeElement)
      .datepicker({
        controlType: 'select',
        oneLine: true,
        // maxDateTime: this.value,
        maxDate: '0',
        setDate: this.value,
        // changeMonth: true,
        // changeYear: true,
        // showButtonPanel: true,
        // minDate: this.minimumDate === false ? '' : new Date(),
        minDate: -30,
        onSelect: (value) => {
          // this.value = value;
          const myDate = new Date(value);
          this.dateChange.next(myDate);
        },
      })
      .datepicker('setDate', this.value);

    // $( "#datepicker" ).datepicker('setDate', $.datepicker.formatDate('mm/dd/yy', new Date(2015,0,23)));
  }

  hideDatePicker() {
    this.hideDatePickerEmit.emit(true);
  }

  showStartDatePicker() {}

  showEndDatePicker() {}
}
